import useAxios from "utils/useAxios";

export const useTaxRegimesAPIService = () => {
    
    const { api } = useAxios();
    const BASE_URL = '/core/taxes/regimes';

    let get = (country) => {
        return api.get(`${BASE_URL}?country=${country}`);
    }

    return {
        get
    }
};

